var modules_e5ab2127 = {"container":"RegionDialog_module_container__f0638e6b","content":"RegionDialog_module_content__f0638e6b","menu":"RegionDialog_module_menu__f0638e6b","list":"RegionDialog_module_list__f0638e6b","list__wrapper":"RegionDialog_module_list__wrapper__f0638e6b","list__item":"RegionDialog_module_list__item__f0638e6b","regionButton":"RegionDialog_module_regionButton__f0638e6b"};
import "../assets/DQAshe2L.css";

export { modules_e5ab2127 as default };
//# sourceMappingURL=RegionDialog.module.less.js.map
